export default __webpack_public_path__ + "static/headerbild.pim-66e44e85f3c56b3d0dbeebb280d804dd.jpg";